function ensureLocalStorageAvailable() {
  try {
    return window && typeof window.localStorage === 'object'
  } catch (e) {
    return false
  }
}

function setLocalItem(key: string, value: string) {
  if (ensureLocalStorageAvailable()) {
    window.localStorage.setItem(key, value)
    return true
  }

  return false
}

function getLocalItem(key: string) {
  if (ensureLocalStorageAvailable()) {
    return window.localStorage.getItem(key)
  }
}

function removeLocalItem(key: string) {
  if (ensureLocalStorageAvailable()) {
    window.localStorage.removeItem(key)
  }
}

export default {
  setLocalItem,
  getLocalItem,
  removeLocalItem,
}
